import React from 'react';
import { FORM_NAME, STEP, STEPS } from './fields';
import { useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { ConfirmationDialog } from 'components/confirmation-dialog';
import { showDialogAction } from 'components/redux-dialog/actions';

const DIALOG_NAME = 'RecordAgainConfirmationDialog';

export const openRecordAgainConfirmationDialog = () => showDialogAction(DIALOG_NAME);

export const RecordAgainConfirmationDialog = () => {
  const dispatch = useDispatch();

  const handleClose = (ok) => {
    if (ok) {
      dispatch(change(FORM_NAME, STEP, STEPS.CONFIGURATION));
    }
  };

  return (
    <ConfirmationDialog
      handleClose={handleClose}
      title="record_again"
      body="exit_recording_body"
      dialogName={DIALOG_NAME}
    />
  );
};
